import { KS_CONTACT, kshetrapalDeveloper, buildFaqs } from "./developer";

const G = "https://shreekshetrapal.in/storage/2026/06";

const elianaCity = {
    slug: "shree-kshetrapal-eliana-city",
    visibility: "public",
    name: "Shree Kshetrapal Eliana City",
    tagline: "Residential Community · Bhuj–Bhachau Highway",
    category: "residential",
    typeLabel: "Residential",
    areaLabel: null,
    city: "Bhuj",
    citySlug: "bhuj",
    locality: "Kukma",
    status: "Under Construction",
    priceLabel: null,
    developer: { name: "Shree Kshetrapal Infra LLP" },
    whatsapp: KS_CONTACT.whatsapp,
    phone: KS_CONTACT.phone,
    phoneDisplay: KS_CONTACT.phoneDisplay,
    coverImage: `${G}/eliana-slider.webp`,
    hero: {
        image: `${G}/eliana-slider.webp`,
        overline: "Residential · Bhuj–Bhachau Highway, Kukma",
        lines: ["Shree Kshetrapal", "Eliana City"],
        sub: "A residential community shaped by visionary planning and innovative design — thoughtfully designed homes with comfort, style and lasting value.",
    },
    sections: [
        {
            type: "overview",
            overline: "Overview",
            title: "Residential living, planned end to end.",
            paragraphs: [
                "Shree Kshetrapal Eliana City is a construction marvel where the best minds have been at work — standing on a solid foundation of visionary planning and innovative design. Renowned architects, structural experts, facade designers and handpicked consultants work in synergy to create a landmark that redefines residential excellence.",
                "Premium construction materials, smart building techniques and a strong focus on green practices are the hallmarks of Eliana City.",
            ],
            facts: [
                { label: "Status", value: "Under Construction" },
                { label: "Type", value: "Residential" },
                {
                    label: "Address",
                    value:
                        "S. No. 317, Sekhpir Circle, Near R.K. Petroleum BPCL, Bhuj–Bhachau Highway, Kukma-Bhuj",
                },
            ],
        },
        {
            type: "highlights",
            overline: "Highlights",
            title: "A community, not just a home.",
            items: [
                {
                    title: "Visionary planning",
                    text: "Designed by renowned architects, structural experts and consultants.",
                },
                {
                    title: "Premium materials",
                    text: "Quality construction materials with smart building techniques.",
                },
                {
                    title: "Green practices",
                    text: "A strong focus on environmentally conscious building.",
                },
                {
                    title: "Clubhouse & game room",
                    text: "Indoor leisure and celebration spaces for residents.",
                },
                {
                    title: "Gardens & gazebos",
                    text: "Serene landscaped gardens, gazebos and a party lawn.",
                },
                {
                    title: "Active living",
                    text: "Outdoor gym, yoga, jogging track and a skating ring.",
                },
            ],
        },
        {
            type: "amenities",
            overline: "Amenities",
            title: "Every day, well lived.",
            note: "Amenity list as published by the developer.",
            items: [
                { icon: "Baby", name: "Children Play Area", desc: "Dedicated play spaces for kids." },
                { icon: "Trees", name: "Gardens", desc: "Serene landscaped greens." },
                { icon: "Landmark", name: "Club House", desc: "Community clubhouse for residents." },
                { icon: "ShieldCheck", name: "Security Cabin", desc: "Manned security at the entrance." },
                { icon: "Dumbbell", name: "Indoor / Outdoor Gym", desc: "Fitness, inside and out." },
                { icon: "Droplets", name: "24×7 Water Supply", desc: "Continuous water infrastructure." },
                { icon: "Sparkles", name: "Yoga & Jogging", desc: "Start the day outdoors." },
                { icon: "Video", name: "CCTV", desc: "Camera surveillance across the community." },
                { icon: "Zap", name: "Skating Ring", desc: "A ring for young skaters." },
                { icon: "Flower2", name: "Gazebos & Party Lawn", desc: "Spaces to unwind and celebrate." },
            ],
        },
        {
            type: "plans",
            overline: "Layout Plan",
            title: "The community layout.",
            note: "Plan as published by the developer. Tap the plan to view it full size.",
            items: [
                { label: "Master Layout", image: `${G}/Layer-1-copy-scaled.webp` },
            ],
        },
        {
            type: "gallery",
            overline: "Gallery",
            title: "Eliana City in renders.",
            caption: "Imagery courtesy of Shree Kshetrapal Infra LLP.",
            images: [
                { src: `${G}/24.webp`, caption: "Architectural render", span: 8 },
                { src: `${G}/3.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/25.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/2.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/26.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/23.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/22.webp`, caption: "Architectural render", span: 8 },
                { src: `${G}/12.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/14.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/27.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/21.webp`, caption: "Architectural render", span: 4 },
                { src: `${G}/20.webp`, caption: "Architectural render", span: 4 },
            ],
        },
        {
            type: "location",
            overline: "Location",
            title: "Bhuj–Bhachau Highway, Kukma.",
            addressLines: [
                "S. No. 317, Sekhpir Circle, Near R.K. Petroleum BPCL,",
                "Bhuj–Bhachau Highway, Kukma-Bhuj, Gujarat",
            ],
            mapUrl: "https://maps.app.goo.gl/56jXvwrzdFGnAErX7",
            landmarks: [
                { name: "Bhuj Railway Station", detail: "10.4 km" },
                { name: "Bhuj Bus Station", detail: "10.6 km" },
                { name: "Jubilee Ground", detail: "10.8 km" },
                { name: "Bhuj Airport", detail: "12.9 km" },
            ],
            note: "Distances as published by the developer.",
        },
        { type: "developer", ...kshetrapalDeveloper },
        buildFaqs("Shree Kshetrapal Eliana City"),
        {
            type: "cta",
            overline: "Connect Directly",
            title: "Talk to the Eliana City team.",
            text: "Ask for current pricing, home availability, payment plans or a site visit — your message goes straight to Shree Kshetrapal Infra LLP. No brokers in between.",
            brochureUrl: "https://shreekshetrapal.in/storage/2026/07/Eliana-City-Brochure.pdf",
        },
    ],
};

export default elianaCity;
